/**
 * Created by Mikhail Menshenin on 29.12.2025
 */

LightningRushStartWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        const styles = cleverapps.styles.LightningRushStartWindow;

        this.mission = mission;

        this._super({
            name: "LightningRushStartWindow",
            title: Messages.get("Missions.LightningRush.Title"),
            content: this.createContent(mission),
            notCloseByTouchInShadow: true,
            closeButtonDelay: true,
            button: {
                width: styles.button.width,
                height: styles.button.height,
                text: this.getButtonText(mission),
                onPressed: this.onPressed.bind(this)
            },
            help: () => GuideWindow.createMissionRulesWindow(mission),
            styles: styles.window,
            timer: mission.getTimeLeft()
        });
    },

    onPressed: function () {
        cleverapps.missionManager.trigger("lightningRushStart", this.mission);
        this.close();
    },

    createContent: function (mission) {
        const styles = cleverapps.styles.LightningRushStartWindow;

        const picture = new cc.Sprite(bundles.lighting_rush_start_window.frames.picture_png);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get(this.chooseText(mission)), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([picture, text], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });
    },

    chooseText: function () {
        let key = "LightningRushStartWindow.description";

        if (!cleverapps.config.features.includes("lives") && Messages.has(`${key}NoLives`)) {
            key += "NoLives";
        }

        return key;
    },

    getButtonText: function () {
        return Messages.get("LightningRushStartWindow.Button");
    },

    listBundles: function () {
        return ["lighting_rush_start_window"];
    }
});

cleverapps.styles.LightningRushStartWindow = {
    margin: 20,
    text: {
        width: 640,
        height: 300
    },
    button: {
        width: 300,
        height: 105
    },
    timer: {
        width: 320,
        height: 0,
        margin: 20,
        padding: {
            x: 10
        },
        layout: {
            x: { align: "left", dx: -20 },
            y: { align: "center" }
        },
        position: [
            { x: { align: "center" }, y: { align: "bottom", dy: -245 } },
            { x: { align: "center" }, y: { align: "bottom", dy: -242 } },
            { x: { align: "center" }, y: { align: "bottom", dy: -242 } }
        ]
    }
};
